import type { FC } from 'react';
import type { FileType, SearchItem } from 'src/components/search';
import { SearchContent } from 'src/components/search';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

interface Props {
  fileType?: FileType;
  onSelectPageInfo?: (pageInfo: SearchItem) => void;
  placeholder?: string;
}
/** 搜索引用文件 */
export const SearchLinkFile: FC<Props> = (props) => {
  const { t } = useAppTranslation();
  const onSelect = (pageInfo: SearchItem) => {
    props?.onSelectPageInfo?.(pageInfo);
  };

  return (
    <SearchContent
      className="py-2.5 relative"
      searchType="file"
      placeholder={props.placeholder || t('common.search_file')}
      onSelect={onSelect}
      fileType={props.fileType}
    />
  );
};
